import React from 'react';
import styled from 'styled-components';

interface Props {
  isLoggedIn: boolean;
  onClickLogin: () => void;
}

const Header = (props: Props) => (
  <Container>
    <Title>CultivAIt: Your CellAg Research Partner</Title>
    <JumboLogin onClick={props.onClickLogin}
      src={props.isLoggedIn ? '/jumbo-blue.png' : '/jumbo-gray.png'} 
      alt={props.isLoggedIn ? 'Logged In' : 'Logged Out'} 
      title={props.isLoggedIn ? 'Log out' : 'Log in'}
    />
  </Container>
);

const Container = styled.div`
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  display: flex;
  font-family: 'Roboto Slab', serif;
  justify-content: space-between;
  padding: 20px 40px;
`;

const Title = styled.div`
  color: #212529;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
`;

const JumboLogin = styled.img`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export default Header;